/**
 * Formats a phone number for display.
 * Handles phone numbers in various formats including +1XXXXXXXXXX
 * @param phone - The phone number to format (can include +1 prefix or just digits)
 * @returns Formatted phone number as (XXX) XXX-XXXX, or empty string if invalid/empty
 */
export function FormatPhone(phone: string | null | undefined): string {
  if (!phone) return '';
  
  // Remove all non-digit characters
  const digitsOnly = phone.replace(/\D/g, '');
  
  // Remove leading 1 if it's an 11-digit number (US country code)
  const cleanedDigits = digitsOnly.length === 11 && digitsOnly.startsWith('1')
    ? digitsOnly.slice(1)
    : digitsOnly;
  
  // If we don't have exactly 10 digits, return the original or cleaned version
  if (cleanedDigits.length !== 10) {
    return phone;
  }
  
  // Format as (XXX) XXX-XXXX
  return `(${cleanedDigits.slice(0, 3)}) ${cleanedDigits.slice(3, 6)}-${cleanedDigits.slice(6)}`;
}

